<template>
  <!-- Mobile Orientation Warning -->
  <div class="mobile-orientation-warning" v-if="showWarning">
    <div class="warning-content">
      <ion-icon name="phone-landscape-outline"></ion-icon>
      <p>Rotate your device for a better experience</p>
    </div>
  </div>
  
  <!-- Loading Indicator for Mobile -->
  <div class="mobile-loading-overlay" v-if="isLoading">
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
    <p>{{ loadingMessage }}</p>
  </div>
</template>

<script>
export default {
  name: 'MobileHelper',
  data() {
    return {
      showWarning: false,
      isLoading: false,
      loadingMessage: 'Loading...',
      orientationTimeout: null
    };
  },
  mounted() {
    this.checkOrientation();
    window.addEventListener('orientationchange', this.handleOrientationChange);
    
    // Listen for custom loading events
    window.addEventListener('app:loading:start', this.startLoading);
    window.addEventListener('app:loading:end', this.stopLoading);
    
    // Default to showing the loading indicator briefly when component mounts
    this.showBriefLoadingIndicator();
  },
  beforeUnmount() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
    window.removeEventListener('app:loading:start', this.startLoading);
    window.removeEventListener('app:loading:end', this.stopLoading);
    clearTimeout(this.orientationTimeout);
  },
  methods: {
    checkOrientation() {
      // Only show warning on very small screens in landscape mode
      // where content might be difficult to view
      if (window.innerWidth < 450 && window.innerWidth > window.innerHeight) {
        this.showWarning = true;
      } else {
        this.showWarning = false;
      }
    },
    handleOrientationChange() {
      this.showWarning = true;
      
      // Hide warning after orientation is complete
      this.orientationTimeout = setTimeout(() => {
        this.checkOrientation();
      }, 500);
    },
    startLoading(event) {
      this.loadingMessage = event.detail?.message || 'Loading...';
      this.isLoading = true;
    },
    stopLoading() {
      this.isLoading = false;
    },
    showBriefLoadingIndicator() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 800);
    }
  }
};
</script>

<style scoped>
.mobile-orientation-warning {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(30, 30, 30, 0.9);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.warning-content {
  padding: 20px;
  color: white;
  animation: fadeIn 0.5s ease-in-out;
}

.warning-content ion-icon {
  font-size: 48px;
  color: #ffd76c;
  animation: rotate 2s infinite ease-in-out;
  margin-bottom: 15px;
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  50% { transform: rotate(90deg); }
  100% { transform: rotate(0deg); }
}

.mobile-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(30, 30, 30, 0.7);
  z-index: 9998;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
}

.spinner {
  margin: 20px auto;
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #ffd76c;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  margin: 0 4px;
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    transform: scale(0);
  } 40% { 
    transform: scale(1.0);
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
